import { SyncLoader } from "react-spinners";

export function Loading() {
  return (
    <div className="flex flex-1 items-center">
      <SyncLoader
        color="hsl(var(--heroui-secondary))"
        size={15}
        margin={10}
        speedMultiplier={0.3}
      />
    </div>
  );
}
